var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 0.339844C8.30751 0.339844 5.31421 3.3955 5.31421 7.16484C5.31421 10.9342 8.30751 13.9898 11.9999 13.9898C15.6923 13.9898 18.6856 10.9342 18.6856 7.16484C18.6856 3.3955 15.6923 0.339844 11.9999 0.339844ZM3.65737 15.6961C1.80948 15.6961 0.299927 17.2093 0.299927 19.1086C0.299927 21.9942 1.69191 24.1698 3.86842 25.5865C6.01114 26.9812 8.89986 27.6398 11.9999 27.6398C15.1 27.6398 17.9887 26.9812 20.1314 25.5865C22.3079 24.1698 23.6999 21.9942 23.6999 19.1086C23.6999 17.2242 22.2032 15.6961 20.3571 15.6961L3.65737 15.6961Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info_icon.86a3f3a275d5110311a605c8ea9aa2a6.svg";
export { ForwardRef as ReactComponent };